/*!
=========================================================
* 入金管理
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardBody, CardTitle, 
  Table, Col, Row,
  FormGroup, 
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import WithRole from '../FormParts/ButtonWithRole';
import Definition from '../../common/Definition';
import InputText from '../FormParts/InputText'
import InputSelect from '../FormParts/InputSelect'
import InputCheckBox from '../FormParts/InputCheckBox'
import InputDatetime from '../FormParts/InputDatetime'
import OptionConvert from '../../common/OptionConvert';
import _ from 'underscore';
import 'moment/locale/ja'
import moment from 'moment/moment'
import Format from '../../common/Format';
import FormatCode from "../../common/FormatCode"
import DialogBase from '../Base/DialogBase';
import InputNumber from '../FormParts/InputNumber';
import ReactTable from "react-table-legacy";
import ListBaseTreeUnlimit from "../Base/ListBaseTreeUnlimit";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import CsvDownloader from "react-csv-downloader";
import { SUSPENSE_RECEIPTS_ACCOUNT_LIST_PER_CUSTOMER } from '../../variables/csv'
import { GetMessage } from "../../variables/message";
import { sortByNumber } from "../../common/Sort"

moment.locale('ja')

moment.updateLocale('ja', {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
});

var domain = "";  

class List extends ListBaseTreeUnlimit {
  default_column = [
    { Header: '入金ID',accessor: 'DEPOSIT__id',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: '入金日',accessor: 'DEPOSIT__deposit_collect_date',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '入金金額',accessor: 'DEPOSIT__deposit_collect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '引き当て済金額合計',accessor: 'DEPOSIT__TEMP1',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '未引き当て残高',accessor: 'DEPOSIT__TEMP2',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '入金種別',accessor: 'DEPOSIT__deposit_collect_type',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, },
    { Header: '顧客名',accessor: '___JOIN_client_master_deposit',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50, },
    { Header: '最終更新情報',accessor: '__JOIN_deposit_update',headerClassName:'text-center',className:'text-left text-top',width:230,minWidth:50, },
    { Header: 'アクション',accessor: 'actions',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50, sortable:false},
  ];
  default_sub_column = [
    { Header: '入金ID',accessor: 'INVOICE__invoice_natural_id',headerClassName:'text-center',className:'text-left text-top',width:500,minWidth:50},
    { Header: '請求金額',accessor: 'ACCOUNTS_RECEIVABLE__invoice_amt',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '引当金額',accessor: 'ACCOUNTS_RECEIVABLE_DETAILS__receivable_collect_amt',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
  ];

  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '入金管理',
      add_url: '',
      search_url: '/api/deposit/unlimit',
      modal_project_id:"",
      column: this.default_column,
      sub_column:this.default_sub_column,
      valid: true,
      searchData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      error:{},
      landmark_user:[],
      landmark_user_branch:[],
      modalData:{
        project_id:'',
        estimateList:[]
      },
      customerList:[],
      auto_scroll:true,
      paging : {
        index : 0,
        limit : 50
      },
      dialogSearchInvoiceData : {
        values:{},
        errors:{},
        requiredData:{}
      },
      show_detail_search_field:false,
      depositedDataList:[],
      oldDepositedDataList:[],
      badge : true,
      tmp_cnt : 0,
      totalSuspenceReceiptsAccountAmt : 0
    });

    this.validateCallback = this.validateCallback.bind(this)
    this.resetDialogData = this.resetDialogData.bind(this)
    this.clickRowCallback = this.clickRowCallback.bind(this)
    this.setDialogData = this.setDialogData.bind(this)
    this.search_count = this.search_count.bind(this);
    this.search = this.search.bind(this)
    // this.searchSuspenseReceiptsAccount = this.searchSuspenseReceiptsAccount.bind(this)
    
    this.dialogSearchInvoice = React.createRef();
    this.dialogCustomerCsvDownload = React.createRef();
    this.dialogDeleteDeposit = React.createRef();
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.optionsById(res.Data)
      this.setState({landmark_user:user_list});
    })

    // 顧客会社検索用プルダウンリスト取得
    Request.get("/api/customer",{without_limit:true}, res => {
      const customerList = res.Data.map(element=>{
        return {
          value:element.customer_natural_id,
          label:element.customer_name,
        }
      })
      this.setState({customerList});
    })

    this.search();
  }

  searchSuspenseReceiptsAccount = () => {
    // 顧客別仮受金取得
    Request.get("/api/suspensereceiptsaccount/customer", {}, res => {
      const suspenceReceiptsAccountCustomerList = res.Data;
      const totalSuspenceReceiptsAccountAmt = suspenceReceiptsAccountCustomerList.reduce((accumulator, currentValue)=>{
        return accumulator + currentValue.suspense_receipts_account_collect_amt || 0;
      }, 0)
      this.setState({suspenceReceiptsAccountCustomerList, totalSuspenceReceiptsAccountAmt});
    })
  }

  resetDialogData(){
    this.setState({
      dialogSearchInvoiceData : {
        values:{},
        errors:{},
        requiredData:{}
      },
      depositedData : [],
      oldDepositedData : [],
    })
  }

  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.landmark_user;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }

  add_button_field(){
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    return (
      <>
        <ButtonWithTooltipWithRole
          onclick={() => {
            this.props.history.push(`/deposit/add`)
          }}
          class="mr-2"
          button_id={"BTN_N1_01_05380"}
          label="入金ファイル読込"
          message="入金ファイル読込画面に遷移します"
        />
        <ButtonWithTooltipWithRole
          onclick={() => {
            this.dialogDeleteDeposit.current.show()
          }}
          class=""
          button_id={"BTN_N1_01_05385"}
          label="入金データ削除"
        />
      </>
    );
  }

  dataMap(data){
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const LinkWithRole = WithRole(Link, this.props.buttons, prop)

      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}

      return {
        id: prop.id,
        DEPOSIT__id: prop.id,
        DEPOSIT__deposit_collect_date: Format.format_date(prop.deposit_collect_date),
        DEPOSIT__deposit_collect_amt: Format.comma_delimited(prop.deposit_collect_amt, "円"),
        DEPOSIT__TEMP1: Format.comma_delimited(prop.sum_collect_amt || 0, "円"),
        DEPOSIT__TEMP2: Format.comma_delimited(prop.deposit_collect_amt - prop.sum_collect_amt || 0, "円"),
        DEPOSIT__deposit_collect_type: FormatCode.decode("cst_deposit_collect_type",prop.deposit_collect_type),
        ___JOIN_client_master_deposit: (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master_deposit', prop)}} />),
        __JOIN_deposit_update : <div dangerouslySetInnerHTML={{__html:Definition.item('__JOIN_deposit_update', prop_tmp)}} />,
        actions: (<>
          <ButtonWithRole 
            button_id="BTN_N1_01_05390"
            size="sm" 
            onClick={(e) => { 

              this.setDialogData(prop.id, () => {
                this.setState({
                  dialogSearchInvoiceData : {
                    values : prop
                  },
                  depositedData : this.state.depositedDataList[prop.id] || [],
                  oldDepositedData : this.state.oldDepositedDataList[prop.id] || []
                }, () => {
                  this.dialogSearchInvoice.current.show()
                })
              })
              
              e.stopPropagation();
            }} 
            className="text-center">{`引き当て設定`}
            </ButtonWithRole>
          </>
        ),
      }
    });
  }
  subDataMap(accountsreceivable){
    return accountsreceivable.map((prop, key) => {
      return {
        id: key,
        INVOICE__invoice_natural_id : (prop.invoice_natural_id +  `（請求金額）${Format.comma_delimited(prop.invoice_amt, "円")}` + `（引当金額）${Format.comma_delimited(prop.receivable_collect_amt, "円")}`)
      }
    });
  }

  setDialogData(deposit_id, callback = () => {}){
    const params = {
      deposit_id : deposit_id
    }

    Request.get("/api/accountsreceivable/detail", params, res => {
      Request.get("/api/oldreceivable/detail", params, oldRes => {

        this.setState({
          depositedDataList : {
            [deposit_id] : res.Data
          },
          oldDepositedDataList : {
            [deposit_id] : oldRes.Data
          }
        }, () => callback())
      });
    });
  }

  clickRowCallback( rowInfo ){
    return new Promise((resolve) => {
      if(!rowInfo.children){
        const params = {
          deposit_id : rowInfo.id
        }
        Request.get("/api/accountsreceivable/detail", params, res => {
          Request.get("/api/oldreceivable/detail", params, oldRes => {
            Request.get("/api/suspensereceiptsaccount", params, susRes => {
              const depositedData = res.Data.map((detail) => {
                return {
                  INVOICE__id : detail.id,
                  INVOICE__invoice_natural_id : `${detail.invoice_natural_id}（請求金額）${Format.comma_delimited(detail.invoice_amt, "円")}（引当金額）${Format.comma_delimited(detail.receivable_collect_amt, "円")}`
                }
              })
              const oldDepositedData = oldRes.Data.map((detail) => {
                return {
                  INVOICE__id : detail.id,
                  INVOICE__invoice_natural_id : `${detail.invoice_natural_id}（未入金額）${Format.comma_delimited(detail.invoice_amt, "円")}（引当金額）${Format.comma_delimited(detail.receivable_collect_amt, "円")}`
                }
              })
              const suspenseData = susRes.Data.map((detail) => {
                return {
                  INVOICE__id : detail.id,
                  INVOICE__invoice_natural_id : `${detail.id}　仮受金（引当金額）${Format.comma_delimited(detail.suspense_receipts_account_collect_amt, "円")}`
                }
              })
              rowInfo.children = [...depositedData, ...oldDepositedData, ...suspenseData]
              this.setState({
                depositedDataList : {
                  ...this.state.depositedDataList,
                  [rowInfo.id] : res.Data
                },
                oldDepositedDataList : {
                  ...this.state.oldDepositedDataList,
                  [rowInfo.id] : oldRes.Data
                }
              })
              resolve(true)
            })
          });
        });
      } else {
        resolve(true)
      }
    })
  }
  
  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        this.setState({data_count: res.Data});
    })
  }

  search(refreshTaskFlag = true) {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    console.log("list paging ", this.state)
    this.search_count();
    var search_param = this.search_params();
    search_param["pager_index"] = "0";
    search_param["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      search_param
      , res => {
        this.setState({
          paging: {
            "index": parseInt(search_param["pager_index"]),
            "limit": parseInt(search_param["pager_limit"])
          }, 
          data: this.dataMap(res.Data),
        })
      }
    )

    this.searchSuspenseReceiptsAccount();

    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }

  validateCallback(newData, callback=()=>{}){
    const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.customer_natural_id)>-1)
    ? {
      customer_natural_id: newData.values.customer_natural_id,
      customer_name: undefined
    } : {
      customer_natural_id:undefined,
      customer_name: newData.values.customer_natural_id
    }
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData,
        values:{
          ...newData.values,
          ...customerParam
        }
      }
    }, ()=>callback())
  }
  
  search_field_cols() {
    console.log('state', this.state)
    return (
      <>
        <Col md="3">
          <InputSelect
            label="顧客会社名"
            labelOn={true}
            name="CUSTOMER__customer_natural_id"
            options={this.state.customerList}
            validateCallback={this.validateCallback} 
            validateType='search'
            isSearchable={true}
            isCreatable={true}
            rootData={this.state.searchData}
            searchStartLength={2}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='入金日（FROM）'
            name='DEPOSIT__deposit_collect_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='入金日（TO）'
            name='DEPOSIT__deposit_collect_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputCheckBox label="引き当て済データも表示"
            name="DEPOSIT__deposit_collect_flag" 
            validateCallback={this.validateCallback} 
            checkedValue={1}
            uncheckedValue={undefined}
            rootData={this.state.searchData}
          />
        </Col>
      </>
    );
  }
  add_field_cols() {
    const ButtonWithRole = WithRole(Button, this.props.buttons)
    return (
    <>
        <Col md="6">
          <Row>
            <Col md="12">
              <div className="float-right">
                仮受金総額：{Format.comma_delimited(this.state.totalSuspenceReceiptsAccountAmt, "円")}
              </div>
            </Col>
            <Col md="12">
              <ButtonWithRole 
                button_id={"BTN_N1_01_05340"}
                onClick={() => {
                  this.setState({
                    dialogTitle : "顧客別仮受金残高CSV",
                  }, () => {
                    this.dialogCustomerCsvDownload.current.show()
                  })
                }}
                className="float-right"
                size="sm"
              >
                顧客別仮受金残高CSV
              </ButtonWithRole>
            </Col>
          </Row>
      </Col>
    </>
    );
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return undefined
  }
  checkbox_field_cols(){
    return (
      <></>
    );
  }
  dialog_defines() {
    return (
      <>
        <DialogSearchInvoice
          ref={this.dialogSearchInvoice}
          data={this.state.dialogSearchInvoiceData}
          depositedData={this.state.depositedData}
          oldDepositedData={this.state.oldDepositedData}
          refreshCallback={this.search}
          resetDialogData={this.resetDialogData}
          negative_label="キャンセル"
          {...this.props}
        />
        <DialogCustomerCsvDownload
          ref={this.dialogCustomerCsvDownload} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          searched_data = {this.state.suspenceReceiptsAccountCustomerList}
          positive={true}
          default_footer={true}
        />
        <DialogDeleteDposit
          ref={this.dialogDeleteDeposit} 
          refreshCallback={this.search}
          positive={true}
          default_footer={true}
        />
      </>
      
    )
  }
}
export default List

export class DialogSearchInvoice extends DialogBase{
  default_column = [
    {
      id: "checkbox",
      accessor: "",
      Cell: ({ original }) => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={this.state.selected[original.ACCOUNTS_RECEIVABLE__invoice_natural_id] === true}
            onChange={() => this.toggleRow(original.ACCOUNTS_RECEIVABLE__invoice_natural_id)}
            disabled={this.state.confirm_flag}
          />
        );
      },
      Header: x => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={this.state.selectAll === 1}
            ref={input => {
              if (input) {
                input.indeterminate = this.state.selectAll === 2;
              }
            }}
            onChange={() => this.toggleSelectAll()}
            disabled={this.state.confirm_flag}
          />
        );
      },
      sortable: false,
      width: 45
    },
    { Header: '請求ID',accessor: 'ACCOUNTS_RECEIVABLE__invoice_natural_id',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50},
    { Header: '請求金額',accessor: 'ACCOUNTS_RECEIVABLE__invoice_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '引き当て済金額',accessor: 'ACCOUNTS_RECEIVABLE__deposit_collect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '引き当て金額',accessor: 'ACCOUNTS_RECEIVABLE__deposit_uncollect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortable:false},
    { Header: '回収状況',accessor: 'ACCOUNTS_RECEIVABLE__accounts_receivable_status',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortable:false},
    { Header: '回収済日付',accessor: 'ACCOUNTS_RECEIVABLE__receivable_collect_finish_date',headerClassName:'text-center',className:'text-left text-top',width:210,minWidth:50, sortable:false},
    { Header: '顧客名',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '工事番号',accessor: 'ACCOUNTS_RECEIVABLE__construction_number',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, },
    { Header: '現場名',accessor: 'ACCOUNTS_RECEIVABLE__site_name',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, },
    { Header: '入金期限',accessor: 'ACCOUNTS_RECEIVABLE__payment_deadline',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
  ];

  default_old_column = [
    {
      id: "checkbox",
      accessor: "",
      Cell: ({ original }) => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={this.state.oldSelected[original.OLD__invoice_natural_id] === true}
            onChange={() => this.oldToggleRow(original.OLD__invoice_natural_id)}
            disabled={this.state.confirm_flag}
          />
        );
      },
      Header: x => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={this.state.oldSelectAll === 1}
            ref={input => {
              if (input) {
                input.indeterminate = this.state.oldSelectAll === 2;
              }
            }}
            onChange={() => this.oldToggleSelectAll()}
            disabled={this.state.confirm_flag}
          />
        );
      },
      sortable: false,
      width: 45
    },
    { Header: '請求ID',accessor: 'OLD__invoice_natural_id',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50},
    { Header: '請求金額',accessor: 'OLD__invoice_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '引き当て済金額',accessor: 'OLD__deposit_collect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '引き当て金額',accessor: 'OLD__deposit_uncollect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortable:false},
    { Header: '回収状況',accessor: 'OLD__accounts_receivable_status',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortable:false},
    { Header: '回収済日付',accessor: 'OLD__receivable_collect_finish_date',headerClassName:'text-center',className:'text-left text-top',width:210,minWidth:50, sortable:false},
    { Header: '顧客名',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '工事番号',accessor: 'OLD__construction_number',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, },
    { Header: '現場名',accessor: 'OLD__site_name',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, },
    { Header: '入金期限',accessor: 'OLD__payment_deadline',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
  ];

  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '引き当て設定',
      data: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      },
      estimateList : [],
      column: this.default_column,
      searchData : {
        values : {
          invoice_natural_id : null,
          invoice_customer_ulid : null,
          invoice_customer_branch_ulid : null,
          customer_name : null
        },
        requiredData : {},
        errors : {},
      },
      oldSearchData : {
        values : {
          invoice_natural_id : null,
          invoice_customer_ulid : null,
          invoice_customer_branch_ulid : null,
          customer_name : null
        },
        requiredData : {},
        errors : {},
      },
      size : "xlg",
      tableData : [],
      selected: {}, 
      selectAll: 0,
      oldTableData : [],
      oldSelected: {}, 
      oldSelectAll: 0,
      search_url : "/api/accountsreceivable/unlimit",
      old_search_url : "/api/oldreceivable",
      originData : [],
      oldOriginData : [],
      total : 0,
      result : 0,
      confirm_modal : false,
      confirm_flag : false,
      checkedItems:[],
      paging:{
        "index": 0,
        "limit": 50
      },
      unique_key:"ACCOUNTS_RECEIVABLE__invoice_natural_id",
      data_count:0,
      all_checked_status:false,
      customerBranchList:[],
      searchMode : 'new' // new:請求データ, old: 旧システムデータ
    });
    this.validate = this.validate.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
    this.validateCallbackForTable = this.validateCallbackForTable.bind(this)
    this.validateSearchCallback = this.validateSearchCallback.bind(this);
    this.validateOldSearchCallback = this.validateOldSearchCallback.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.oldToggleRow = this.oldToggleRow.bind(this);
    this.toggleConfirmModal = this.toggleConfirmModal.bind(this);
    this.negativeConfirmModal = this.negativeConfirmModal.bind(this);
  }

  componentDidUpdate(prevProps){
    if (this.props.data.values.id && prevProps.data.values.id !== this.props.data.values.id){
      // 顧客支店リスト取得
      Request.get("/api/customer/branch",{
        customer_ulid:this.props.data.values.invoice_customer_ulid,
        customer_branch_delete_flag : 1
      }, res => {
        const customerBranchList = res.Data.map(element=>{
          return {
            value:element.ulid,
            label:element.customer_branch_name
          }
        })
        this.setState({
          customerBranchList : customerBranchList
        })
      })

      // 顧客リスト取得(旧システム検索用)
      Request.get(this.state.old_search_url, {}, res => {
        const customerArray = res.Data.map((item) => (item.customer_name))
        const customerSet = new Set(customerArray);
        const customerList = [...customerSet].map(item=>{
          return {
            value:item,
            label:item
          }
        })
        this.setState({
          customerList : customerList
        }, () => {
          const confirm_flag = this.props.data.values.deposit_collect_status === 1 ? true : false
          const tableData = this.dataMap(this.props.depositedData || [], confirm_flag)
          const oldTableData = this.oldDataMap(this.props.oldDepositedData || [], confirm_flag)
          const deposit_collect_customer_branch_flag = this.props.data.values.deposit_collect_customer_branch_flag
          this.setState({
            searchData :{
              ...this.state.searchData,
              values:{
                ...this.state.searchData.values,
                invoice_customer_ulid : this.props.data.values.invoice_customer_ulid,
                invoice_customer_branch_ulid : deposit_collect_customer_branch_flag === 1 && this.props.data.values.invoice_customer_branch_ulid
              }
            },
            oldSearchData :{
              ...this.state.oldSearchData,
              values:{
                ...this.state.oldSearchData.values,
              }
            },
            data:{
              ...this.props.data,
            },
            tableData : tableData,
            oldTableData : oldTableData,
            originData : this.props.depositedData,
            oldOriginData : this.props.oldDepositedData,
            confirm_flag : confirm_flag,
            searchMode : 'new'
          }, () => {
            this.calculate();
          })
        })
      })
    }
  }

  dataMap(data, confirm_flag = false){
    return data.map((prop, key) => {
      const collect_amt = confirm_flag ? prop.receivable_collect_amt : prop.deposit_collect_total_amt;
      return {
        id: prop.invoice_natural_id,
        ACCOUNTS_RECEIVABLE__invoice_natural_id: prop.invoice_natural_id,
        ACCOUNTS_RECEIVABLE__invoice_amt: Format.comma_delimited(prop.invoice_amt, "円"),
        ACCOUNTS_RECEIVABLE__deposit_collect_amt: Format.comma_delimited(collect_amt, "円"),
        ACCOUNTS_RECEIVABLE__deposit_uncollect_amt: 
          <InputNumber
            label='引き当て金額'
            name='ACCOUNTS_RECEIVABLE__deposit_uncollect_amt'
            labelOn={false}
            disabled={confirm_flag}
            validateCallback={(newData) => this.validateCallbackForTable(newData, prop, key)}
            rootData={{
              values : { 
                deposit_uncollect_amt : prop.deposit_uncollect_amt }
              }
            }
            size={12}
          />,
        ACCOUNTS_RECEIVABLE__accounts_receivable_status : 
          (
            confirm_flag === false ?
            <InputCheckBox
              label="回収済"
              labelOn={false}
              name="ACCOUNTS_RECEIVABLE__accounts_receivable_status"
              checkedValue={2} // 0:未回収、1:一部回収、2:回収済
              uncheckedValue={1}
              validateCallback={(newData) => this.validateCallbackForTable(newData, prop, key)}
              rootData={{
              values : { 
                accounts_receivable_status : prop.accounts_receivable_status }
              }}
            />
          :
          FormatCode.decode("cst_accounts_receivable_status", prop.accounts_receivable_status)
        ),
        ACCOUNTS_RECEIVABLE__receivable_collect_finish_date : 
          (
            confirm_flag === false ?
            <InputDatetime
              label="回収済日付"
              labelOn={false}
              name="ACCOUNTS_RECEIVABLE__receivable_collect_finish_date"
              timeFormat={true}
              validateCallback={(newData) => this.validateCallbackForTable(newData, prop, key)}
              rootData={{
              values : { 
                receivable_collect_finish_date : prop.receivable_collect_finish_date || "" }
              }}
            />
          :
          Format.format_date(prop.receivable_collect_finish_date)
        ),
        ___JOIN_client_master: (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />),
        ACCOUNTS_RECEIVABLE__construction_number: prop.construction_number,
        ACCOUNTS_RECEIVABLE__site_name: prop.site_name,
        ACCOUNTS_RECEIVABLE__payment_deadline : Format.format_date(prop.payment_deadline),
        update_timestamp : prop.update_timestamp
      }
    });
  }

  oldDataMap(data, confirm_flag = false){
    return data.map((prop, key) => {
      const collect_amt = confirm_flag ? prop.receivable_collect_amt : prop.deposit_collect_total_amt;
      return {
        id: prop.invoice_natural_id,
        OLD__invoice_natural_id: prop.invoice_natural_id,
        OLD__invoice_amt: Format.comma_delimited(prop.invoice_amt, "円"),
        OLD__deposit_collect_amt: Format.comma_delimited(collect_amt, "円"),
        OLD__deposit_uncollect_amt: 
          <InputNumber
            label='引き当て金額'
            name='OLD__deposit_uncollect_amt'
            labelOn={false}
            disabled={confirm_flag}
            validateCallback={(newData) => this.validateCallbackForOldTable(newData, prop, key)}
            rootData={{
              values : { 
                deposit_uncollect_amt : prop.deposit_uncollect_amt }
              }
            }
            size={12}
          />,
          OLD__accounts_receivable_status : 
          (
            confirm_flag === false ?
            <InputCheckBox
              label="回収済"
              labelOn={false}
              name="OLD__accounts_receivable_status"
              checkedValue={2} // 0:未回収、1:一部回収、2:回収済
              uncheckedValue={1}
              validateCallback={(newData) => this.validateCallbackForOldTable(newData, prop, key)}
              rootData={{
              values : { 
                accounts_receivable_status : prop.accounts_receivable_status }
              }}
            />
          :
          FormatCode.decode("cst_accounts_receivable_status", prop.accounts_receivable_status)
        ),
        OLD__receivable_collect_finish_date : 
          (
            confirm_flag === false ?
            <InputDatetime
              label="回収済日付"
              labelOn={false}
              name="OLD__receivable_collect_finish_date"
              timeFormat={true}
              validateCallback={(newData) => this.validateCallbackForOldTable(newData, prop, key)}
              rootData={{
              values : { 
                receivable_collect_finish_date : prop.receivable_collect_finish_date || "" }
              }}
            />
          :
          Format.format_date(prop.receivable_collect_finish_date)
        ),
        ___JOIN_client_master: (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />),
        OLD__construction_number: prop.construction_number,
        OLD__site_name: prop.site_name,
        OLD__payment_deadline : Format.format_date(prop.payment_deadline),
        update_timestamp : prop.update_timestamp
      }
    });
  }

  toggleRow(ACCOUNTS_RECEIVABLE__invoice_natural_id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[ACCOUNTS_RECEIVABLE__invoice_natural_id] = !this.state.selected[ACCOUNTS_RECEIVABLE__invoice_natural_id];

    console.log("newSelected ", newSelected)
		this.setState({
			selected: newSelected,
			selectAll: 2,
		}, () => {
      this.calculate();
    });
	}

  oldToggleRow(OLD__invoice_natural_id) {
		const newSelected = Object.assign({}, this.state.oldSelected);
		newSelected[OLD__invoice_natural_id] = !this.state.oldSelected[OLD__invoice_natural_id];
		this.setState({
			oldSelected: newSelected,
			oldSelectAll: 2,
		}, () => {
      this.calculate();
    });
	}

  calculate(){
    const selectedData = this.state.tableData.filter((item) => {
      return this.state.selected[item.ACCOUNTS_RECEIVABLE__invoice_natural_id] === true
    })

    const oldSelectedData = this.state.oldTableData.filter((item) => {
      return this.state.oldSelected[item.OLD__invoice_natural_id] === true
    })

    // 入金金額
    const deposit_amt = this.state.data.values.deposit_collect_amt || 0;

    // 引当合計
    let total = 0
    if(this.state.confirm_flag){
      total = this.props.depositedData.reduce((acc, cur) => {
        return acc + cur.receivable_collect_amt || 0
      }, 0)

      total = this.props.oldDepositedData.reduce((acc, cur) => {
        return acc + cur.receivable_collect_amt || 0
      }, total)
    } else {
      total = selectedData.reduce((acc, cur) => {
        return acc + cur.ACCOUNTS_RECEIVABLE__deposit_uncollect_amt.props.rootData.values.deposit_uncollect_amt || 0
      }, 0)

      total = oldSelectedData.reduce((acc, cur) => {
        return acc + cur.OLD__deposit_uncollect_amt.props.rootData.values.deposit_uncollect_amt || 0
      }, total)
    }
    const result = deposit_amt - total
    this.setState({
      total,
      result
    })
  }

	toggleSelectAll() {
		let newSelected = {};

		if (this.state.selectAll === 0) {
			this.state.tableData.forEach(x => {
				newSelected[x.ACCOUNTS_RECEIVABLE__invoice_natural_id] = true;
			});
		}

		this.setState({
			selected: newSelected,
			selectAll: this.state.selectAll === 0 ? 1 : 0
		}, () => {
      this.calculate();
    });
	}

  oldToggleSelectAll() {
		let newSelected = {};

		if (this.state.oldSelectAll === 0) {
			this.state.oldTableData.forEach(x => {
				newSelected[x.OLD__invoice_natural_id] = true;
			});
		}

		this.setState({
			oldSelected: newSelected,
			oldSelectAll: this.state.oldSelectAll === 0 ? 1 : 0
		}, () => {
      this.calculate();
    });
	}

  validate() {
    let messageList = []

    const selectedData = this.state.tableData.filter((item) => {
      return this.state.selected[item.ACCOUNTS_RECEIVABLE__invoice_natural_id] === true
    })

    const oldSelectedData = this.state.oldTableData.filter((item) => {
      return this.state.oldSelected[item.OLD__invoice_natural_id] === true
    })

    // 入金金額
    const deposit_collect_amt = this.state.data.values.deposit_collect_amt
    // 入金合計
    const total_amt = this.state.total

    // 入金金額がプラスの場合は引当残高 ＞０ は確定できない
    if(deposit_collect_amt >= 0 && deposit_collect_amt < total_amt){
      messageList.push(2484)
    }

    // 入金額がマイナスの場合は引き当て設定できない
    if(deposit_collect_amt < 0 && (selectedData.length > 0 || oldSelectedData.length > 0)){
      messageList.push(2485)
    }

    //引当残高あり且つ「残額を仮受金にする」をチェックしてない場合
    if(this.state.result !== 0 && this.state.data.values.suspense_receipts_account_flag !== 1){
      messageList.push(2480)
    }

    // 回収済にチェックがあるの場合は回収済日付を必須とする
    const checkData = selectedData.filter(item =>
       (item.ACCOUNTS_RECEIVABLE__accounts_receivable_status.props.rootData.values.accounts_receivable_status === 2 
        && (item.ACCOUNTS_RECEIVABLE__receivable_collect_finish_date.props.rootData.values.receivable_collect_finish_date === null
         || item.ACCOUNTS_RECEIVABLE__receivable_collect_finish_date.props.rootData.values.receivable_collect_finish_date === "")))
    const oldCheckData = oldSelectedData.filter(item =>
    (item.OLD__accounts_receivable_status.props.rootData.values.accounts_receivable_status === 2 
      && (item.OLD__receivable_collect_finish_date.props.rootData.values.receivable_collect_finish_date === null
      || item.OLD__receivable_collect_finish_date.props.rootData.values.receivable_collect_finish_date === "")))
    if(checkData.length > 0 || oldCheckData.length > 0){
      messageList.push(2482)
    }

    const selectedIdArr = selectedData.map(item => item.id)
    const oldSelectedIdArr = oldSelectedData.map(item => item.id)

    const seletedOriginData = this.state.originData.filter(item => (selectedIdArr.includes(item.invoice_natural_id)))
    const oldSeletedOriginData = this.state.oldOriginData.filter(item => (oldSelectedIdArr.includes(item.invoice_natural_id)))

    // 引き当て設定する請求書の残額チェック
    // 残額がある場合はメッセージを表示する（無視して登録は可能）
    let isUncollectAmt = false
    let overDetailCount = false
    seletedOriginData.forEach(item => {
      const accounts_receivable_status = item.accounts_receivable_status
      const invoice_amt = item.invoice_amt || 0;
      const deposit_collect_total_amt = item.deposit_collect_total_amt || 0;
      const deposit_uncollect_amt = item.deposit_uncollect_amt || 0;
      const calcAmt = invoice_amt - deposit_collect_total_amt - deposit_uncollect_amt;
      if(accounts_receivable_status === 2 && calcAmt !== 0){
        isUncollectAmt = true;
      }

      if(item.detail_count >= 10){
        overDetailCount = true;
      }
    })

    oldSeletedOriginData.forEach(item => {
      const accounts_receivable_status = item.accounts_receivable_status
      const invoice_amt = item.invoice_amt || 0;
      const deposit_collect_total_amt = item.deposit_collect_total_amt || 0;
      const deposit_uncollect_amt = item.deposit_uncollect_amt || 0;
      const calcAmt = invoice_amt - deposit_collect_total_amt - deposit_uncollect_amt;
      if(accounts_receivable_status === 2 && calcAmt !== 0){
        isUncollectAmt = true;
      }
    })
    if(isUncollectAmt){
      this.setState({
        confirmMessage : GetMessage(2483)
      })
    } else {
      this.setState({
        confirmMessage : undefined
      })
    }

    if(overDetailCount){
      messageList.push(2488)
    }

    if(messageList.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:messageList});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    const data = this.state.data;
    this.setState({
      data:{
        ...data,
        ...newData
      }
    }, ()=>callback())
  }

  validateCallbackForTable(newData, prop, key){
    this.setState({
      tableData : [
        ...this.state.tableData.slice(0, key),
        {
          ...this.state.tableData[key],
          ACCOUNTS_RECEIVABLE__deposit_uncollect_amt : {
            ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__deposit_uncollect_amt,
            props : {
              ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__deposit_uncollect_amt.props,
              rootData : {
                ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__deposit_uncollect_amt.props.rootData,
                values : {
                  ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__deposit_uncollect_amt.props.rootData.values,
                  ...newData.values
                }
              }
            }
          },
          ACCOUNTS_RECEIVABLE__accounts_receivable_status : {
            ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__accounts_receivable_status,
            props : {
              ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__accounts_receivable_status.props,
              rootData : {
                ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__accounts_receivable_status.props.rootData,
                values : {
                  ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__accounts_receivable_status.props.rootData.values,
                  ...newData.values
                }
              }
            }
          },
          ACCOUNTS_RECEIVABLE__receivable_collect_finish_date : {
            ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__receivable_collect_finish_date,
            props : {
              ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__receivable_collect_finish_date.props,
              rootData : {
                ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__receivable_collect_finish_date.props.rootData,
                values : {
                  ...this.state.tableData[key].ACCOUNTS_RECEIVABLE__receivable_collect_finish_date.props.rootData.values,
                  ...newData.values
                }
              }
            }
          },
        },
        ...this.state.tableData.slice(key+1),
      ],
      originData : [
        ...this.state.originData.slice(0, key),
        {
          ...this.state.originData[key],
          deposit_uncollect_amt : newData.values.deposit_uncollect_amt ? newData.values.deposit_uncollect_amt : this.state.originData[key].deposit_uncollect_amt,
          accounts_receivable_status : newData.values.accounts_receivable_status ? newData.values.accounts_receivable_status : this.state.originData[key].accounts_receivable_status,
          receivable_collect_finish_date : newData.values.receivable_collect_finish_date ? newData.values.receivable_collect_finish_date : this.state.originData[key].receivable_collect_finish_date,
        },
        ...this.state.originData.slice(key+1),
      ]
    }, () => {
      this.calculate();
    })
  }

  validateCallbackForOldTable(newData, prop, key){
    this.setState({
      oldTableData : [
        ...this.state.oldTableData.slice(0, key),
        {
          ...this.state.oldTableData[key],
          OLD__deposit_uncollect_amt : {
            ...this.state.oldTableData[key].OLD__deposit_uncollect_amt,
            props : {
              ...this.state.oldTableData[key].OLD__deposit_uncollect_amt.props,
              rootData : {
                ...this.state.oldTableData[key].OLD__deposit_uncollect_amt.props.rootData,
                values : {
                  ...this.state.oldTableData[key].OLD__deposit_uncollect_amt.props.rootData.values,
                  ...newData.values
                }
              }
            }
          },
          OLD__accounts_receivable_status : {
            ...this.state.oldTableData[key].OLD__accounts_receivable_status,
            props : {
              ...this.state.oldTableData[key].OLD__accounts_receivable_status.props,
              rootData : {
                ...this.state.oldTableData[key].OLD__accounts_receivable_status.props.rootData,
                values : {
                  ...this.state.oldTableData[key].OLD__accounts_receivable_status.props.rootData.values,
                  ...newData.values
                }
              }
            }
          },
          OLD__receivable_collect_finish_date : {
            ...this.state.oldTableData[key].OLD__receivable_collect_finish_date,
            props : {
              ...this.state.oldTableData[key].OLD__receivable_collect_finish_date.props,
              rootData : {
                ...this.state.oldTableData[key].OLD__receivable_collect_finish_date.props.rootData,
                values : {
                  ...this.state.oldTableData[key].OLD__receivable_collect_finish_date.props.rootData.values,
                  ...newData.values
                }
              }
            }
          },
        },
        ...this.state.oldTableData.slice(key+1),
      ],
      oldOriginData : [
        ...this.state.oldOriginData.slice(0, key),
        {
          ...this.state.oldOriginData[key],
          deposit_uncollect_amt : newData.values.deposit_uncollect_amt ? newData.values.deposit_uncollect_amt : this.state.oldOriginData[key].deposit_uncollect_amt,
          accounts_receivable_status : newData.values.accounts_receivable_status ? newData.values.accounts_receivable_status : this.state.oldOriginData[key].accounts_receivable_status,
          receivable_collect_finish_date : newData.values.receivable_collect_finish_date ? newData.values.receivable_collect_finish_date : this.state.oldOriginData[key].receivable_collect_finish_date,
        },
        ...this.state.oldOriginData.slice(key+1),
      ]
    }, () => {
      this.calculate();
    })
  }

  validateSearchCallback(newData, callback=()=>{}){
    const customerBranchParam = 
    (this.state.customerBranchList.findIndex(customer=>customer.value==newData.values.invoice_customer_branch_ulid)>-1)
    ? {
      invoice_customer_branch_ulid: newData.values.invoice_customer_branch_ulid,
      invoice_customer_branch_name: undefined
    }
    : {
      invoice_customer_branch_ulid: undefined,
      invoice_customer_branch_name: newData.values.invoice_customer_branch_ulid
    }

    this.setState({
      searchData:{
        ...this.state.searchData,
        values:{
          ...this.state.searchData.values,
          ...newData.values,
          ...customerBranchParam
        }
      }
    }, ()=>{
      console.log(this.state.searchData)
      callback()
    })
  }

  validateOldSearchCallback(newData, callback=()=>{}){
    this.setState({
      oldSearchData:{
        ...this.state.oldSearchData,
        ...newData,
        values:{
          ...newData.values,
        }
      }
    }, ()=>{
      callback()
    })
  }

  

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  old_search_params() {
    const {values} = this.state.oldSearchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        // console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }

  old_search_count() {
    var search_param = this.old_search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.old_search_url, search_param, res => {
        this.setState({data_count: res.Data});
    })
  }

  search(){
    // API：売掛金検索
    this.search_count();
    let searchParmas = this.search_params()

    Request.get(this.state.search_url, searchParmas, (res)=>{
      this.setState({
        selected : {}, // 検索時はチェック初期化
        tableData: this.dataMap(res.Data),
        originData: res.Data,
      }, () => {
        this.calculate();
      });
    })
  }

  oldSearch(){
    this.old_search_count();
    let searchParmas = this.old_search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];

    Request.get(this.state.old_search_url, searchParmas, (res)=>{
    
      this.setState({
        oldSelected : {}, // 検索時はチェック初期化
        oldTableData: this.oldDataMap(res.Data),
        oldOriginData: res.Data,
        paging: {
          "index": parseInt(searchParmas["pager_index"]),
          "limit": parseInt(searchParmas["pager_limit"])
        },
      }, () => {
        this.calculate();
      });
    })
  }

  toggleConfirmModal() {
    if(this.validate()){
      this.setState({
        confirm_modal: !this.state.confirm_modal
      });
    }
  }
  negativeConfirmModal() {
    this.setState({
      confirm_modal: false
    });
  }

  regist(){
    const url = '/api/deposit/accountsreceivable';

    const selectedData = this.state.tableData.filter((item) => {
      return this.state.selected[item.ACCOUNTS_RECEIVABLE__invoice_natural_id] === true
    })

    const dataParam = selectedData.map((item) => {
      const accounts_receivable_status = item.ACCOUNTS_RECEIVABLE__accounts_receivable_status.props.rootData.values.accounts_receivable_status
      return {
        invoice_natural_id : item.id,
        deposit_uncollect_amt : item.ACCOUNTS_RECEIVABLE__deposit_uncollect_amt.props.rootData.values.deposit_uncollect_amt,
        accounts_receivable_status : accounts_receivable_status === 0 ? 1 : accounts_receivable_status,
        receivable_collect_finish_date : item.ACCOUNTS_RECEIVABLE__receivable_collect_finish_date.props.rootData.values.receivable_collect_finish_date,
        update_timestamp : item.update_timestamp
      }
    })

    const oldSelectedData = this.state.oldTableData.filter((item) => {
      return this.state.oldSelected[item.OLD__invoice_natural_id] === true
    })

    const oldDataParam = oldSelectedData.map((item) => {
      const accounts_receivable_status = item.OLD__accounts_receivable_status.props.rootData.values.accounts_receivable_status
      return {
        invoice_natural_id : item.id,
        deposit_uncollect_amt : item.OLD__deposit_uncollect_amt.props.rootData.values.deposit_uncollect_amt,
        accounts_receivable_status : accounts_receivable_status === 0 ? 1 : accounts_receivable_status,
        receivable_collect_finish_date : item.OLD__receivable_collect_finish_date.props.rootData.values.receivable_collect_finish_date,
        update_timestamp : item.update_timestamp
      }
    })
    
    const params = {
      deposit_id : this.state.data.values.id, // 入金ID
      deposit_collect_date : this.state.data.values.deposit_collect_date, // 入金日
      deposit_collect_type : this.state.data.values.deposit_collect_type, // 入金種別
      suspense_receipts_account_flag : this.state.data.values.suspense_receipts_account_flag, // 仮受金フラグ
      suspense_receipts_account_collect_amt : this.state.result, // 仮受金（引き当て残高）
      update_timestamp : this.state.data.values.update_timestamp,
      data : dataParam,
      oldData : oldDataParam
    }

    Request.post(url, params, res => {
      if(res.data.Code === 200){
        const newDataMap = this.dataMap(this.state.originData || [], true);
        const newSelectedData = newDataMap.filter((item) => {
          return this.state.selected[item.ACCOUNTS_RECEIVABLE__invoice_natural_id] === true
        })

        const oldDataMap = this.oldDataMap(this.state.oldOriginData || [], true);
        const oldSelectedData = oldDataMap.filter((item) => {
          return this.state.oldSelected[item.OLD__invoice_natural_id] === true
        })
        this.setState({
          tableData : newSelectedData,
          oldTableData : oldSelectedData,
          confirm_flag : true
        })
        this.props.refreshCallback();
      }
    });
  }

  handleClickNegative() {
    this.props.resetDialogData();
    this.setState({
      modal: false,
      confirm_flag : null,
      searchData : {
        values : {
          invoice_natural_id : null,
          invoice_customer_ulid : null,
          invoice_customer_branch_ulid : null,
          customer_name : null
        },
      },
      oldSearchData : {
        values : {
          invoice_natural_id : null,
          invoice_customer_ulid : null,
          invoice_customer_branch_ulid : null,
          customer_name : null
        },
      },
    });
  }

  bodyContent(){
    const ButtonWithRole = WithRole(Button, this.props.buttons)

    const textDecoration  =  'underline'
    return(
      <>
        <Row style={{paddingLeft : "15px"}}>
          <div
            style={{
              backgroundColor: (this.state.searchMode === 'new' ?'#b2dff9':'lightgrey'),
              display: 'inline-block',
              padding: '0 30px',
              borderRadius: '10px 10px 0 0',
              cursor:'pointer', 
              textDecoration
            }}
            onClick={()=>{
              this.setState({
                searchMode : 'new'
              })
            }}
          >
            請求データ検索
          </div>
          <div
            style={{
              backgroundColor: (this.state.searchMode === 'old' ?'#b2dff9':'lightgrey'),
              display: 'inline-block',
              padding: '0 30px',
              borderRadius: '10px 10px 0 0',
              cursor:'pointer', 
              textDecoration : ""
            }}
            onClick={()=>{
              this.setState({
                searchMode : 'old'
              })
            }}
          >
            旧システムの未収金データを検索
          </div>
          
        </Row>
        {this.state.searchMode === 'new' ?
          <Row style={{paddingTop : "10px"}}>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputText
                label='請求ID'
                name='ACCOUNTS_RECEIVABLE__invoice_natural_id'
                labelOn={true}
                validateCallback={this.validateSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.searchData}
                validateType={'search'}
              />
            </Col>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputDatetime
                label='入金期限（FROM)'
                name='ACCOUNTS_RECEIVABLE__payment_deadline_from'
                labelOn={true}
                validateCallback={this.validateSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.searchData}
                validateType={'search'}
              />
            </Col>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputDatetime
                label='入金期限（TO)'
                name='ACCOUNTS_RECEIVABLE__payment_deadline_to'
                labelOn={true}
                validateCallback={this.validateSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.searchData}
                validateType={'search'}
              />
            </Col>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputSelect
                label="顧客支店名"
                labelOn={true}
                name="ACCOUNTS_RECEIVABLE__invoice_customer_branch_ulid"
                options={this.state.customerBranchList}
                validateCallback={this.validateSearchCallback} 
                validateType='search'
                rootData={this.state.searchData}
                isSearchable={true}
                isCreatable={true}
                disabled={this.state.data.values.deposit_collect_customer_branch_flag === 1}
              />
            </Col>
            <Col md="3">
              <InputNumber
                label='請求金額（FROM）'
                name='ACCOUNTS_RECEIVABLE__invoice_amt_from'
                labelOn={true}
                validateCallback={this.validateSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.searchData}
                validateType={'search'}
                size={12}
              />
            </Col>
            <Col md="3">
              <InputNumber
                label='請求金額（TO）'
                name='ACCOUNTS_RECEIVABLE__invoice_amt_to'
                labelOn={true}
                validateCallback={this.validateSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.searchData}
                validateType={'search'}
                size={12}
              />
            </Col>
            <Col md="3">
              <ButtonWithRole 
                // button_id="BTN_N1_01_05400"
                size="sm" 
                onClick={() => { 
                  this.search();
                }} 
                disabled={this.state.confirm_flag}
                className="text-center">{`検索`}
                </ButtonWithRole>
            </Col>
          </Row>
        :
          <Row style={{paddingTop : "10px"}}>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputText
                label='請求ID'
                name='OLD__invoice_natural_id'
                labelOn={true}
                validateCallback={this.validateOldSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.oldSearchData}
                validateType={'search'}
              />
            </Col>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputDatetime
                label='入金期限（FROM)'
                name='OLD__payment_deadline_from'
                labelOn={true}
                validateCallback={this.validateOldSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.oldSearchData}
                validateType={'search'}
              />
            </Col>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputDatetime
                label='入金期限（TO)'
                name='OLD__payment_deadline_to'
                labelOn={true}
                validateCallback={this.validateOldSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.oldSearchData}
                validateType={'search'}
              />          
            </Col>
            <Col xl="3" lg="3" md="3" sm="4">
              <InputSelect
                label="顧客名"
                labelOn={true}
                name="OLD__customer_name"
                options={this.state.customerList}
                validateCallback={this.validateOldSearchCallback} 
                validateType='search'
                rootData={this.state.oldSearchData}
                isSearchable={true}
                isCreatable={true}
                // disabled={this.state.data.values.deposit_collect_customer_branch_flag === 1}
              />
            </Col>
            <Col md="3">
              <InputNumber
                label='請求金額（FROM）'
                name='OLD__invoice_amt_from'
                labelOn={true}
                validateCallback={this.validateOldSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.oldSearchData}
                validateType={'search'}
                size={12}
              />
            </Col>
            <Col md="3">
              <InputNumber
                label='請求金額（TO）'
                name='OLD__invoice_amt_to'
                labelOn={true}
                validateCallback={this.validateOldSearchCallback}
                enterCallback={this.searchWithPageIndex}
                enterSearchFlag={true}
                rootData={this.state.oldSearchData}
                validateType={'search'}
                size={12}
              />
            </Col>
            <Col md="3">
              <ButtonWithRole 
                // button_id="BTN_N1_01_05400"
                size="sm" 
                onClick={() => { 
                  this.oldSearch();
                }} 
                disabled={this.state.confirm_flag}
                className="text-center">{`検索`}
                </ButtonWithRole>
            </Col>
          </Row>
        }
        <Row style={{paddingTop : "10px"}}>
          <Col>
            入金金額：{Format.comma_delimited(this.state.data.values.deposit_collect_amt, "円")}
          </Col>
          <Col>
            引当合計：{Format.comma_delimited(this.state.total, "円")}
          </Col>
          {this.state.confirm_flag === false ?
            <>
              <Col>
                引当残高：{Format.comma_delimited(this.state.result, "円")}
              </Col>
              <Col>
                <InputCheckBox
                  label='残額を仮受金にする'
                  name='SUSPENSE_RECEIPTS_ACCOUNT__suspense_receipts_account_flag'
                  validateCallback={this.validateCallback}
                  checkedValue={1}
                  uncheckedValue={undefined}
                  rootData={this.state.data}
                  validateType={'search'}
                />
              </Col>
            </>
          :
            <>
              <Col>
                引当残高：{Format.comma_delimited(0, "円")}
              </Col>
              <Col>
                仮受金：{Format.comma_delimited(this.state.result, "円")}
              </Col>
            </>
          }
            
          <Col>
            {this.state.confirm_flag === false ?
              <ButtonWithRole 
              // button_id="BTN_N1_01_05410"
              size="sm" 
              onClick={() => { 
                this.toggleConfirmModal()
              }} 
              className="text-center">{`確定`}
              </ButtonWithRole>
              :
              <ButtonWithRole 
              // button_id="BTN_N1_01_05420"
              size="sm" 
              onClick={() => { 
                this.handleClickNegative()
              }} 
              className="text-center">{`閉じる`}
              </ButtonWithRole>
            }
          </Col>
        </Row>
        <Row>
          <Col>
            {
              this.state.searchMode === 'new' ?
                <ReactTable
                  data={this.state.tableData || []}
                  columns={this.default_column}
                  minRows={3}
                  defaultPageSize={3}
                  previousText="前へ"
                  nextText="次へ"
                  rowsText="件表示"
                  loadingText='読込中…'
                  noDataText='検索してください'
                  pageText=''
                  ofText='/'
                  showPageSizeOptions={false}
                  // getTableProps={() => {
                  //   return {
                  //     style: { overflow: 'visible' }
                  //   };
                  // }}
                  getTbodyProps={() => {
                    return {
                      style: { overflow: 'visible' }
                    };
                  }}
                  getTdProps={(state, rowInfo, column) => {
                    const { id } = column;
                    return {
                      style: { overflow: 'visible' }
                    };
                  }}
                />
              :
                <ReactTable
                  data={this.state.oldTableData || []}
                  columns={this.default_old_column}
                  minRows={3}
                  defaultPageSize={3}
                  previousText="前へ"
                  nextText="次へ"
                  rowsText="件表示"
                  loadingText='読込中…'
                  noDataText='検索してください'
                  pageText=''
                  ofText='/'
                  showPageSizeOptions={false}
                  // getTableProps={() => {
                  //   return {
                  //     style: { overflow: 'visible' }
                  //   };
                  // }}
                  getTbodyProps={() => {
                    return {
                      style: { overflow: 'visible' }
                    };
                  }}
                  getTdProps={(state, rowInfo, column) => {
                    const { id } = column;
                    return {
                      style: { overflow: 'visible' }
                    };
                  }}
                />
            }
          </Col>
        </Row>
        <hr />
        <Modal isOpen={this.state.confirm_modal} toggle={this.toggleConfirmModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.negativeConfirmModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{'引き当て設定を確定します。よろしいですか？'}</h5>
          </div>
          <ModalBody>
            <div style={{color : "red"}}>{GetMessage(2486)}</div>
            <div style={{color : "red"}}>{this.state.confirmMessage}</div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.negativeConfirmModal}>
              いいえ
            </Button>
            <ButtonWithRole 
              // button_id={this.state.view?"BTN_M2_04_04370":"BTN_M2_02_04310"}
              color="info" 
              onClick={() => { 
                this.negativeConfirmModal(); 
                this.regist(); 
              }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export class DialogCustomerCsvDownload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.makeCsv = this.makeCsv.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: this.props.dialogTitle+'をします。よろしいですか？',
      });
    }
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  makeCsv(suspenceReceiptsAccountCustomerList){
    const csvData = suspenceReceiptsAccountCustomerList.reduce((acc, data) => {

      acc.push([
        this.isNullOrUndefined(data.customer_name) ? "" : data.customer_name,
        this.isNullOrUndefined(data.suspense_receipts_account_collect_amt) ? 0 : data.suspense_receipts_account_collect_amt,
      ])
      return acc
    }, [[...SUSPENSE_RECEIPTS_ACCOUNT_LIST_PER_CUSTOMER.HEADER]])

    return this.wrappingQuote(csvData);
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      <>
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            const csvData = await this.makeCsv(this.props.searched_data);
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`deposit_list_per_customer_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}

export class DialogDeleteDposit extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '削除する入金データを選択してください',
      data : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.validateCallback = this.validateCallback.bind(this)
    this.deleteDeposit = this.deleteDeposit.bind(this)
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.modal !== this.state.modal && this.state.modal === true){

      // 削除可能な日時を取得し、プルダウンに設定する
      Request.get("/api/deposit/delete", {}, res => {
        const importDateList = res.Data.map(item => ({
          value : {
            file_import_date : item.file_import_date,
            update_timestamp : item.update_timestamp
          },
          label : Format.format_datetime(item.file_import_date) + ` （${item.count}件）`,
        }))
        this.setState({
          importDateList : importDateList
        });
      });
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      }
    }, ()=>callback())
  }

  handleClickNegative() {
    this.setState({
      modal: false,
      data : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });
  }

  deleteDeposit(){
    const {
      file_import_date,
      update_timestamp
    } = this.state.data.values.file_import_info;
    Request.put("/api/deposit/delete/update", { file_import_date, update_timestamp }, res => {
      this.toggleDeleteModal();
      this.handleClickNegative();
      this.props.refreshCallback();
    });
  }

  toggleDeleteModal() {
    this.setState({
      delete_modal: !this.state.delete_modal
    });
  }

  bodyContent() {
    return (
      <>
        <Row>
          <Col>
            <h5>{'引き当て設定が行われてない入金データのみ表示されます'}</h5>
          </Col>
        </Row>
        <Row>
          <Col>
            <InputSelect
              label="削除対象ファイルの取込日時"
              labelOn={true}
              name="TEMP__file_import_info"
              options={this.state.importDateList}
              validateCallback={this.validateCallback} 
              rootData={this.state.data}
              isSearchable={true}
            />
          </Col>
        </Row>
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>キャンセル</Button>
          <Button color="info" onClick={()=> {
            // 削除対象確認、対象がなかったらモーダル表示しない
            if(!this.state.data.values.file_import_info){
              return;
            }
            this.toggleDeleteModal()
          }}>削除</Button>
        </div>

        <Modal isOpen={this.state.delete_modal} toggle={this.toggleDeleteModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleDeleteModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{"入金データ削除"}</h5>
          </div>
          <ModalBody>
            <p>入金データを削除します。よろしいですか</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleDeleteModal}>
              いいえ
            </Button>
            <Button 
              color="info" 
              onClick={() => { 
                console.log("削除"); 
                this.deleteDeposit();
              }}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}